<template>
  <div class="chatHistory">
    <el-dialog
      :title="`与${patientMap.patientName}的聊天记录`"
      center
      :visible.sync="visible"
      width="560px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content">
        <div class="header">
          <el-input
            class="header_search"
            v-model="search"
            placeholder="请输入..."
            prefix-icon="el-icon-search"
            clearable
            @input="searchInput">
          </el-input>
        </div>
        <div ref="chat_list" class="list" v-loading="chatLoading">
          <div v-for="chat in chatMap.list" :key="chat.vId" :ref="`chat_record_${chat.vId}`" class="item">
            <div class="item_header">
              <img class="item_header_img" :src="chat.sendRole == '0' ? doctorMap.headerImg : imgArr.chat_user">
            </div>
            <div class="item_info">
              <div class="item_info_header">
                <div class="info_name">{{ chat.sendRole == '0' ? doctorMap.doctorName : patientMap.patientName }}</div>
                <div class="info_time">{{ dateFormat(chat.createTime) }}</div>
              </div>
              <div class="chat_info">
                <div v-if="chat.messageType === 0" class="chat_text">{{ chat.content }}</div>
                <div v-if="chat.messageType === 1" class="chat_image">
                  <img class="chat_image_img" :src="chat.content">
                </div>
                <div v-if="chat.messageType === 3" class="chat_voice">
                  <audio class="chat_voice_audio" :src="chat.content.content" controls></audio>
                </div>
                <div v-if="chat.messageType === 4" class="chat_inquiry" @click="toInquiry(chat)">
                  <div class="inquiry_title">问诊单</div>
                  <div class="inquiry_info">{{ chat.content.webChatInquiryInfo.status == '0' ? '患者未填写' : (chat.content.webChatInquiryInfo.status == '1' ? '患者已填写完成' : '') }}</div>
                  <div class="inquiry_footer">{{ chat.content.webChatInquiryInfo.status == '0' ? '等待患者填写' : '查看问诊单' }}</div>
                </div>
                <div v-if="chat.messageType === 8" class="chat_plan">
                  <div class="plan_header">
                    <div class="plan_header_title">治疗方案</div>
                    <div v-if="chat.content.diagnosisResp && chat.content.diagnosisResp.status" class="plan_header_status" :style="`color: ${ planOrderStatusMap[chat.content.diagnosisResp.status + ''].color }`">{{ planOrderStatusMap[chat.content.diagnosisResp.status + ''].label }}</div>
                    <div v-else-if="chat.orderInfoStatus" class="plan_header_status" :style="`color: ${ planOrderInfoStatusMap[chat.orderInfoStatus + ''].color }`">{{ planOrderInfoStatusMap[chat.orderInfoStatus + ''].label }}</div>
                  </div>
                  <div class="plan_patient">患者： {{ chat.content.patient.patientName }} {{ chat.content.patient.sex == 0 ? '男' : '女' }} {{ chat.content.patient.age }}岁</div>
                  <div v-if="chat.content.diagnosisResp" class="plan_diagnosis">诊断： {{ chat.content.diagnosisResp.diagnosis }}</div>
                  <div v-if="chat.content" class="plan_content">
                    <span>方案：</span>
                    <span v-if="chat.content.chDoseNum">中药处方{{ chat.content.chDoseNum }}剂，</span>
                    <span v-if="chat.content.physioItems">理疗项目{{ chat.content.physioItems }}项，</span>
                    <span v-if="chat.content.otherItems">其他项目{{ chat.content.otherItems }}项，</span>
                  </div>
                </div>
                <div v-if="chat.messageType === 10" class="chat_condition" @click="toInquiry(chat)">
                  <div class="condition_title">病情描述</div>
                  <div v-if="chat.content.webChatInquiryInfo" class="condition_list">
                    <div v-for="question in chat.content.webChatInquiryInfo.questions" :key="question.id" class="condition_item">
                      <div v-if="question.questionsTitle === '病情描述'" class="condition_description">{{question.questionsTitle}}：{{question.selectAnswerId}}</div>
                      <div v-else :class="{ condition_row: question.questionsType != 3 }">
                        <div class="condition_row_title">{{question.questionsTitle}}：</div>
                        <div v-if="question.questionsType == 3" class="condition_row_imgRow">
                          <div v-if="question.imgList.length === 0" class="condition_answer_text">无</div>
                          <img v-for="(conditionImg, conditionImgIndex) in question.imgList" :key="conditionImgIndex" class="condition_row_img" :src="conditionImg">
                        </div>
                        <div v-else>
                          <div v-if="question.answers && question.answers.length > 0">
                            <div v-for="answer in question.answers" :key="answer.id" v-if="question.selectAnswerId == answer.answerId" class="condition_answer_text">{{ answer.answerContent }}</div>
                          </div>
                          <div v-else class="condition_answer_text">{{ question.selectAnswerId }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="condition_footer">查看病情描述</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { imgArr } from "@/assets/images/img.js"

  import { debounce } from '@/utils/validateBase'

  import { getWebchatRecords } from "@/api/webchat"

  export default {
    name: 'chatHistory',
    data () {
      return {
        imgArr: imgArr,
        planOrderStatusMap: {
          '-7': { label: '已退费', color: '#667182' },
          '-5': { label: '已超时', color: '' },
          '-4': { label: '已跑单', color: '' },
          '-3': { label: '已退款', color: '' },
          '-2': { label: '已停诊', color: '' },
          '-1': { label: '已取消', color: '#667182' },
          '0': { label: '未支付', color: '#FE8F1F' },
          '1': { label: '待签到', color: '' },
          '2': { label: '待就诊', color: '' },
          '3': { label: '已就诊', color: '' },
          '4': { label: '已收费', color: '#29C01B' },
          '6': { label: '已完成', color: '' },
          '7': { label: '已叫号', color: '' },
          '8': { label: '待支付', color: '#FE8F1F' },
          '9': { label: '已关闭', color: '' },
          '11': { label: '待审核', color: '#1890FF' },
          '15': { label: '已拒绝', color: '#F54A45' }
        },
        planOrderInfoStatusMap: {
          '-7': { label: '已退费', color: '#667182' },
          '-6': { label: '草稿', color: '' },
          '-5': { label: '已超时', color: '' },
          '-4': { label: '已跑单', color: '' },
          '-3': { label: '已退款', color: '' },
          '-2': { label: '已停诊', color: '' },
          '-1': { label: '已取消', color: '#667182' },
          '0': { label: '未支付', color: '#FE8F1F' },
          '1': { label: '待签到', color: '' },
          '2': { label: '待就诊', color: '' },
          '3': { label: '已就诊', color: '' },
          '4': { label: '已划价', color: '#29C01B' },
          '5': { label: '正在看诊', color: '#29C01B' },
          '6': { label: '已完成', color: '' },
          '7': { label: '已叫号', color: '' },
          '8': { label: '待支付', color: '#FE8F1F' },
          '9': { label: '已关闭', color: '#667182' },
          '11': { label: '待审核', color: '#1890FF' },
          '15': { label: '已拒绝', color: '#F54A45' }
        },
        visible: false,
        webChatOrderInfoId: '',
        doctorMap: {
          doctorId: '',
          doctorName: '',
          headerImg: ''
        },
        patientMap: {
          patientId: '',
          patientName: '',
          headerImg: ''
        },
        search: '',
        chatLoading: false,
        chatMap: {
          hasMore: true,
          list: [],
          pageNo: 1,
          pageSize: 20
        }
      }
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      dateFormat (date) {
        const today = new Date().Format('yyyy-MM-dd')
        const yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).Format('yyyy-MM-dd')
        const dateMap = {
          [today]: '今天',
          [yesterday]: '昨天'
        }

        const day = new Date(date).Format('yyyy-MM-dd')
        const time = new Date(date).Format('hh:mm')
        
        return `${dateMap[day] || day} ${time}`
      },
      // 获取就诊单的方案 例：中药处方*剂  理疗项目*项 其他项目*项
      getPlanData(data) {
        if (data.messageType == 8) {
          let projectRecipes = data.content.projectRecipes || []
          // 中药  0:其他   1：中药   2：隐秘   3：理疗
          let items = projectRecipes.filter(vs => {
            return vs.recipeType == 1
          })
          let doseNum = items.reduce((pre, cur) => {
            return pre + cur.doseNum
          }, 0)
          data.content.chMed = items
          data.content.chDoseNum = doseNum
          // 理疗
          let physioItems = 0
          projectRecipes.map(vs => {
            if (vs.recipeType == 3) {
              physioItems += vs.items && vs.items.length
            }
          })
          data.content.physioItems = physioItems
          // 其他
          let otherItems = 0
          projectRecipes.map(vs => {
            if (vs.recipeType == 0) {
              otherItems += vs.items && vs.items.length
            }
          })
          data.content.otherItems = otherItems
        }
        return data
      },
      async getChatList () {
        this.chatLoading = true
        const res = await getWebchatRecords({
          webChatOrderInfoId: this.webChatOrderInfoId,
          doctorId: this.doctorMap.doctorId,
          patientId: this.patientMap.patientId,
          role: '0',
          content: this.search,
          pageNum: this.chatMap.pageNo,
          pageSize: this.chatMap.pageSize
        })
        this.chatLoading = false
        if (res.code === 200) {
          if (res.rows.length > 0) {
            const oldFirstChatVId = this.chatMap.list[0] && this.chatMap.list[0].vId || ''
            const list = res.rows.reverse()
            list.map(v => {
              v['vId'] = this.generateUUID()
              switch (v.messageType) {
                case 1:
                  v.content = v.content + `?v=${Date.now()}`
                  break
                case 3:
                  v.content = JSON.parse(v.content)
                  break
                case 4:
                  v.content = JSON.parse(v.content)
                  v = this.getPlanData(v)
                  break
                case 8:
                  v.content = JSON.parse(v.content)
                  v = this.getPlanData(v)
                  break
                case 10:
                  v.content = JSON.parse(v.content)
                  v = this.getPlanData(v)

                  if (v.content.webChatInquiryInfo && v.content.webChatInquiryInfo.questions) {
                    v.content.webChatInquiryInfo.questions.map(v2 => {
                      if (v2.questionsType === 3) {
                        v2['imgList'] = (v2.selectAnswerId && v2.selectAnswerId.split(',')) || []
                      }
                    })
                  }
                  break
              }
              return v
            })
            this.chatMap.list = list.filter(v => { return v.messageType !== 2 }).concat(this.chatMap.list)
            if (this.chatMap.pageNo === 1) {
              this.$nextTick(() => {
                this.$refs['chat_list'].scrollTop = this.$refs['chat_list'].scrollHeight
              })
            } else {
              this.$nextTick(() => {
                this.$refs['chat_list'].scrollTop = this.$refs[`chat_record_${oldFirstChatVId}`][0].offsetTop
              })
            }
          } else {
            this.chatMap.hasMore = false
          }
        }
      },
      searchInput: debounce(function () {
        this.chatMap.list = []
        this.chatMap.pageNo = 1
        this.chatMap.hasMore = true

        this.getChatList()
      }, 400),
      toInquiry (chat) {
        this.$parent.toInquiry(chat)
      },
      open (info) {
        const data = JSON.parse(JSON.stringify(info))
        this.visible = true
        this.webChatOrderInfoId = data.webChatOrderInfoId
        this.doctorMap.doctorId = data.doctorMap.doctorId
        this.doctorMap.doctorName = data.doctorMap.doctorName
        this.doctorMap.headerImg = data.doctorMap.headerImg
        this.patientMap.patientId = data.patientMap.patientId
        this.patientMap.patientName = data.patientMap.patientName
        this.patientMap.headerImg = data.patientMap.headerImg

        this.getChatList()
      },
      close () {
        this.webChatOrderInfoId = ''
        this.doctorId = ''
        this.patientId = ''
        this.patientName = ''

        this.chatMap.hasMore = true
        this.chatMap.list = []
        this.chatMap.pageNo = 1

        this.search = ''

        this.visible = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .chatHistory /deep/ .el-dialog__header {
    box-sizing: border-box;
    padding: 12px 24px;
    width: 100%;
    height: 48px;
    background-color: #FAFAFA;;
    border-bottom: 1px solid #EBEAEE !important;
  }

  .chatHistory /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .chatHistory /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .chatHistory /deep/ .el-dialog__body {
    padding: 0;
  }

  .chatHistory /deep/ .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #EBEAEE;
  }

  .content {
    width: 100%;
  }

  .header {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    background-color: #FAFAFA;
    border-bottom: 1px solid #EBEAEE;
  }

  .header_search {
    width: 100%;
  }

  .list {
    box-sizing: border-box;
    padding: 0 0 32px 0 ;
    width: 100%;
    height: 590px;
    background-color: #F6F7F8;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .item {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    overflow: hidden;
  }

  .item_header {
    flex-shrink: 0;
    margin: 0 0 0 24px;
    padding: 12px 0;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    overflow: hidden;
  }

  .item_header_img {
    width: 100%;
    height: 100%;
  }

  .item_info {
    flex-grow: 1;
    margin: 0 0 0 8px;
    padding: 12px 24px 12px 0;
    border-bottom: 1px solid #EBEAEE;
  }

  .item_info_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .info_name {
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .info_time {
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .chat_info {
    margin: 2px 0 0 0;
    width: 100%;
  }

  .chat_text {
    box-sizing: border-box;
    padding: 6px 10px;
    line-height: 20px;
    font-size: 14px;
    color: #1F2329;
    word-wrap: break-word;
    word-break: break-all;
  }

  .chat_image {
    box-sizing: border-box;
    padding: 6px 10px;
    overflow: hidden;
  }

  .chat_image_img {
    width: 50px;
    height: 50px;
  }

  .chat_voice {
    box-sizing: border-box;
    padding: 6px 10px;
    width: fit-content;
    background-color: #FFFFFF;
    border-radius: 2px;
    overflow: hidden;
  }

  .chat_voice_audio {
    width: 280px;
    height: 32px;
  }

  .chat_inquiry {
    box-sizing: border-box;
    padding: 6px 10px;
    width: 200px;
    background-color: #FFFFFF;
    border-radius: 2px;
    overflow: hidden;
    cursor: pointer;
  }

  .inquiry_title {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .inquiry_info {
    margin: 4px 0 0 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .inquiry_footer {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    padding: 6px 0 0 0;
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    color: #A4AFBA;
    text-align: center;
    border-top: 1px solid #E0E0E0;
  }

  .chat_plan {
    box-sizing: border-box;
    padding: 6px 10px;
    width: 200px;
    background-color: #FFFFFF;
    border-radius: 2px;
    overflow: hidden;
  }

  .plan_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .plan_header_title {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .plan_header_status {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
  }

  .plan_patient {
    margin: 4px 0 0 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .plan_diagnosis {
    margin: 4px 0 0 0;
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .plan_content {
    margin: 4px 0 0 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
    word-wrap: break-word;
    word-break: break-all;
  }

  .chat_condition {
    box-sizing: border-box;
    padding: 6px 10px;
    width: 200px;
    background-color: #FFFFFF;
    border-radius: 2px;
    overflow: hidden;
    cursor: pointer;
  }

  .condition_title {
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .condition_list {
    margin: 4px 0 0 0;
  }

  .condition_item {
    margin: 4px 0 0 0;
  }

  .condition_description {
    max-height: 72px;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  .condition_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 0;
  }

  .condition_row_title {
    flex-shrink: 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .condition_row_imgRow {
    width: 100%;
  }

  .condition_row_img {
    margin: 5px 5px 0 0;
    width: 50px;
    height: 50px;
  }

  .condition_answer_text {
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .condition_footer {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    padding: 6px 0 0 0;
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    color: #A4AFBA;
    text-align: center;
    border-top: 1px solid #E0E0E0;
  }
</style>